export default "__VITE_ASSET__1628322d__"